/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import classnames from 'classnames';
import * as _ from 'lodash';

import {
  AppNavCancelButton,
  AppNavSubmitButton,
  AppNavNextButton,
  AppNavPrevButton,
  AppNavDoneButton,
  AppNavEditButton,
  AppNavCloseButton,
  AppNavLogoutButton,
  AppNavBackButton,
  AppNavLoginButton,
  AppNavCloseIconButton,
  AppNavNotificationOrAvatarButton,
  AppNavButtonPlaceholder,
  AppNavSignUpButton,
  AppNavInviteButton,
  AppNavAcceptButton,
} from './AppNavButtons';
import NotificationsButton from './NotificationsButton';
import UI_CONSTANTS from '../../../../constants/uiConstants';

const throttle = (f) => {
  return _.throttle(f, 2000, { trailing: false });
};

function getRightSideButton(p) {
  if (p.submit) {
    return <AppNavSubmitButton text={p.submitText} onClick={throttle(p.submit)} onDisabledClick={p.onDisabledClick} isDisabled={p.submitDisabled} {...p.submitProps}/>;
  } else if (p.invite) {
    return <AppNavInviteButton text={p.submitText} onClick={throttle(p.invite)} onDisabledClick={p.onDisabledClick} isDisabled={p.submitDisabled} {...p.submitProps}/>;
  } else if (p.accept) {
    return <AppNavAcceptButton text={p.submitText} onClick={throttle(p.accept)} onDisabledClick={p.onDisabledClick} isDisabled={p.submitDisabled} {...p.submitProps}/>;
  } else if (p.next) {
    return <AppNavNextButton text={p.submitText} onClick={throttle(p.next)} onDisabledClick={p.onDisabledClick} isDisabled={p.submitDisabled} color={p.color} {...p.nextProps}/>;
  } else if (p.edit) {
    return <AppNavEditButton onClick={throttle(p.edit)} color={p.color} />;
  } else if (p.done) {
    return <AppNavDoneButton onClick={throttle(p.done)} color={p.color} isDisabled={p.submitDisabled} onDisabledClick={p.onDisabledClick} />;
  } else if (p.close) {
    return <AppNavCloseButton onClick={throttle(p.close)} color={p.color} />;
  } else if (p.closeIcon) {
    return <AppNavCloseIconButton onClick={throttle(p.closeIcon)} color={p.color} />;
  } else if (p.logout) {
    return <AppNavLogoutButton onClick={throttle(p.logout)} color={p.color} />;
  } else if (p.avatarAction) {
    return <AppNavNotificationOrAvatarButton onClick={throttle(p.avatarAction)} profile={p.profile} />;
  } else if (p.notification) {
    return <NotificationsButton />;
  } else {
    return <AppNavButtonPlaceholder />;
  }
}

function getLeftSideButton(p) {
  if (p.goBack) {
    return <AppNavBackButton onClick={throttle(p.goBack)} />;
  } else if (p.cancel) {
    return <AppNavCancelButton onClick={throttle(p.cancel)} color={p.color} />;
  } else if (p.login) {
    return <AppNavLoginButton onClick={throttle(p.login)} />;
  } else if (p.signUp) {
    return <AppNavSignUpButton onClick={throttle(p.signUp)} />;
  } else if (p.prev) {
    return <AppNavPrevButton onClick={throttle(p.prev)} />;
  } else if (p.notification) {
    return <NotificationsButton className="left-side" />;
  } else {
    return <AppNavButtonPlaceholder />;
  }
}

interface Props {
  className?: string;
  rowClassName?: string;
  color?: string;
  height?: string;
  goBack?(): void;
  cancel?(): void;
  login?(): void;
  signUp?(): void;
  notification?(): void;
  submit?(data): void;
  invite?(data): void;
  next?(): void;
  edit?(): void;
  prev?(): void;
  done?(data): void;
  close?(data): void;
  closeIcon?(data): void;
  logout?(): void;
  submitDisabled?: boolean;
  submitText?: string;
  children?: any;
  profile?: any;
  avatarAction?(): void;
  style?: any;
  nextProps?: any;
  submitProps?: any;
}

const AppNavLeftRightNavigation = (props: Props) => {
  const { className, style } = props;
  const classNames = classnames('cmp-appnavlefrightnavigation', className);
  return (
    <>
    <div className={className} style={{ paddingTop: UI_CONSTANTS.statusBarHeight, backgroundColor: style ? style.backgroundColor : null }} />
    <header className={classNames} style={style}>
      {getLeftSideButton(props)}
      {props.children}
      {getRightSideButton(props)}
    </header>
    </>
  );
};

AppNavLeftRightNavigation['defaultProps'] = {
  nextProps: {},
  submitProps: {},
};

export default AppNavLeftRightNavigation;
